export default __webpack_public_path__ + "static/media/tick-cross-icon.6a42cb0a.svg";